<div class="registrazione-container">

  <!-- SINISTRA — brand -->
  <div class="reg-brand">
    <div class="brand-content">
      <img src="nyzed-wordmark.png" alt="Nyzed" class="brand-logo-full" />
      <h1 class="brand-title">Benvenuta.</h1>
      <p class="brand-tagline">{{ "register.tagline" | translate }}</p>
      <div class="brand-features">
        <div class="brand-feature">
          <strong class="feature-label">{{ "register.feature1_label" | translate }}</strong>
          <span>{{ "register.feature1" | translate }}</span>
        </div>
        <div class="brand-feature">
          <strong class="feature-label">{{ "register.feature2_label" | translate }}</strong>
          <span>{{ "register.feature2" | translate }}</span>
        </div>
        <div class="brand-feature">
          <strong class="feature-label">{{ "register.feature3_label" | translate }}</strong>
          <span>{{ "register.feature3" | translate }}</span>
        </div>
      </div>
    </div>
    <div class="brand-decoration"></div>
  </div>

  <!-- DESTRA — form -->
  <div class="reg-form-side">
    <div class="reg-card">

      <ng-container *ngIf="!registered; else registeredState">
      <h2>{{ "register.title" | translate }}</h2>

      <form (ngSubmit)="onSubmit()" [formGroup]="registration">

        <!-- Dati -->
        <p class="section-label">{{ "register.data_label" | translate }}</p>

        <div class="input-row">
          <div class="input-group">
            <input type="text" formControlName="name" [placeholder]="'register.name' | translate" class="input-field" />
          </div>
          <div class="input-group">
            <input type="text" formControlName="lastname" [placeholder]="'register.lastname' | translate" class="input-field" />
          </div>
        </div>

        <div class="input-group">
          <input type="text" formControlName="username" [placeholder]="'register.username' | translate" class="input-field" />
        </div>

        <div class="input-group">
          <input
            type="email"
            formControlName="email"
            [placeholder]="'register.email' | translate"
            class="input-field"
            [class.invalid]="email?.invalid && (email?.dirty || email?.touched)"
            autocapitalize="off"
          />
          <small class="error-msg" *ngIf="email?.invalid && (email?.dirty || email?.touched)">
            {{ "register.email_invalid" | translate }}
          </small>
        </div>

        <div class="input-row">
          <div class="input-group password-group">
            <input
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              [placeholder]="'register.password' | translate"
              class="input-field"
              appCapsLock
              #capsPwd="capsLock"
            />
            <button
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="(showPassword ? 'common.hide_password' : 'common.show_password') | translate"
            >
              <svg *ngIf="!showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1.5 12s4-7.5 10.5-7.5S22.5 12 22.5 12s-4 7.5-10.5 7.5S1.5 12 1.5 12Z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 3l18 18"/>
                <path d="M10.6 5.2c.45-.05.92-.08 1.4-.08 6.5 0 10.5 7.5 10.5 7.5a17.9 17.9 0 0 1-4.14 5.02M6.5 6.5C3.6 8.3 1.5 12 1.5 12s4 7.5 10.5 7.5c1.7 0 3.2-.4 4.5-1.05"/>
                <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/>
              </svg>
            </button>
          </div>
          <div class="input-group password-group">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              formControlName="confermaPassword"
              [placeholder]="'register.confirm_password' | translate"
              class="input-field"
              appCapsLock
              #capsPwd2="capsLock"
            />
            <button
              type="button"
              class="password-toggle"
              (click)="toggleConfirmPasswordVisibility()"
              [attr.aria-label]="(showConfirmPassword ? 'common.hide_password' : 'common.show_password') | translate"
            >
              <svg *ngIf="!showConfirmPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1.5 12s4-7.5 10.5-7.5S22.5 12 22.5 12s-4 7.5-10.5 7.5S1.5 12 1.5 12Z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showConfirmPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 3l18 18"/>
                <path d="M10.6 5.2c.45-.05.92-.08 1.4-.08 6.5 0 10.5 7.5 10.5 7.5a17.9 17.9 0 0 1-4.14 5.02M6.5 6.5C3.6 8.3 1.5 12 1.5 12s4 7.5 10.5 7.5c1.7 0 3.2-.4 4.5-1.05"/>
                <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/>
              </svg>
            </button>
          </div>
        </div>
        <small class="caps-hint" *ngIf="capsPwd.capsOn || capsPwd2.capsOn">
          <app-icon name="alert" [size]="14" /> {{ "common.caps_lock_on" | translate }}
        </small>

        <app-turnstile
        [siteKey]="turnstileSiteKey"
        (tokenGenerated)="onCaptchaToken($event)"
        (tokenExpired)="captchaToken = null">
      </app-turnstile>

        <button type="submit" [disabled]="!captchaToken" class="submit-button">{{ "register.submit" | translate }}</button>
      </form>

      <div class="or-divider"><span>{{ 'register.or_divider' | translate }}</span></div>

      <app-google-signin-button
        [clientId]="googleClientId"
        (success)="onGoogleSuccess($event)"
        (failure)="onGoogleFailure($event)">
      </app-google-signin-button>

      <p class="login-link">
        {{ "register.hasAccount" | translate }} <a (click)="login()">{{ "register.login" | translate }}</a>
      </p>
      </ng-container>

      <ng-template #registeredState>
        <div class="success-box">
          <span class="success-icon">✦</span>
          <h2>{{ "register.check_email_title" | translate }}</h2>
          <p>{{ "register.check_email_text" | translate }}</p>
          <p class="success-hint">{{ "register.check_email_hint" | translate }}</p>
        </div>
        <p class="login-link" style="margin-top:1.5rem">
          <a (click)="login()">{{ "register.login" | translate }}</a>
        </p>
      </ng-template>

    </div>
  </div>

</div>
